import Constant from '@/const';
import axios from 'axios';

const postDrugs = async payload => {
  try {
    const response = await axios.post(
      Constant.apiUrl.concat(`/master/drugs`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default postDrugs;
